import './FabItem.3d257668934363d8f02512b5b9ee8ceb.css';
export default {"fabItem":"_fabItem_gy4cj_1","wrapper":"_wrapper_gy4cj_1","text":"_text_gy4cj_1"};